export const pdfFileExtension = "pdf";

const checkPdfFileExension = (fileName) => {
  if (fileName.search(`.${pdfFileExtension}`) === -1) {
    return `${fileName}.${pdfFileExtension}`;
  }
  return fileName;
};

export const Download = {
  pdfUsingModernAnchorTag: ({ fileName, url }) => {
    fileName = checkPdfFileExension(fileName);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    a.remove();
  },
  pdfUsingMsSaveBlob: (blob, fileName) => {
    fileName = checkPdfFileExension(fileName);
    navigator.msSaveBlob(blob, fileName);
  }
};
